export default "__VITE_ASSET__e35d7894__"